function enableInput(input: HTMLInputElement | null, inputWrapper: HTMLElement | null) {
	if (input !== null) {
		input.disabled = false;
		input.readOnly = false;
		input.style.backgroundColor = "";
		input.style.removeProperty("border-color");
	}
	if (inputWrapper !== null) {
		inputWrapper.style.display = "";
	}
}

export default enableInput;
